import axios from './_nestAxios'

export const obtenerxIdAsEdicionSinDocumento = id =>
  axios.get(`/cajas-chicas/${id}`, {
    params: {
      tipoConsulta: 'sin-documento'
    }
  })

export const obtenerxIdAsEdicionConDocumento = id =>
  axios.get(`/cajas-chicas/${id}`, {
    params: {
      tipoConsulta: 'con-documento'
    }
  })

export const obtenerxIdTituloViatico = idTituloViatico =>
  axios.get('/cajas-chicas', {
    params: {
      idTituloViatico
    }
  })

export const nuevoSinDocumento = data =>
  axios.post('/cajas-chicas', data, {
    params: {
      tipoConsulta: 'sin-documento'
    }
  })

export const nuevoConDocumento = data =>
  axios.post('/cajas-chicas', data, {
    params: {
      tipoConsulta: 'con-documento'
    }
  })

export const procesarxIdTituloViatico = idTituloViatico =>
  axios.post('/cajas-chicas/procesar', null, {
    params: {
      idTituloViatico
    }
  })

export const actualizarSinDocumentoxId = (id, data) =>
  axios.put(`/cajas-chicas/${id}`, data, {
    params: {
      tipoConsulta: 'sin-documento'
    }
  })

export const actualizarConDocumentoxId = (id, data) =>
  axios.put(`/cajas-chicas/${id}`, data, {
    params: {
      tipoConsulta: 'con-documento'
    }
  })

export const eliminarxId = id => axios.delete(`/cajas-chicas/${id}`)
